module.exports = __webpack_public_path__ + "static/grid-1b8f8a54eba99a14d7096d7f11bd9c37.png";